module.exports = __webpack_public_path__ + "static/media/TableScratch_Before.ea5ebe4c.jpg";